// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

export default {
  name: 'ansible',
  title: 'label.ansible',
  icon: 'SyncOutlined',
  docHelp: 'ansible-integration.html',
  permission: ['getAnsibleStatus', 'listAnsibleTasks'],
  children: [
    {
      name: 'ansible/configuration',
      title: 'label.ansible.configuration',
      icon: 'setting-outlined',
      docHelp: 'ansible-integration.html#configuration',
      permission: ['getAnsibleStatus', 'enableAnsible'],
      component: () => import('@/views/plugins/ansible/ManageAnsible.vue')
    },
    {
      name: 'ansible/task-list',
      title: 'label.ansible.list',
      icon: 'bars-outlined',
      permission: ['listAnsibleTasks'],
      component: () => import('@/views/plugins/ansible/ListTasks.vue')
    }
  ]
}
